var StreamHandler = require("streamhandler");
var util = require("./lib/util.es6");


var XHRStreamHandler = function (url) {
    StreamHandler.call(this);
    this.url = url;
    this.xhr = new XMLHttpRequest();
    
    this._initXhr();
    debug.log('XHR', 'construct', this.url, this.xhr);
};
XHRStreamHandler.UNSENT = 0;
XHRStreamHandler.OPENED = 1;
XHRStreamHandler.HEADERS_RECEIVED = 2;
XHRStreamHandler.LOADING = 3;
XHRStreamHandler.DONE = 4;
XHRStreamHandler.prototype = util.inherit(StreamHandler, {
    getHandler: function () {
        return this.xhr;
    },
    isOpen: function () {
        return this._getReadyState() > XHRStreamHandler.UNSENT && this._getReadyState() < XHRStreamHandler.DONE;
    },
    isConnecting: function () {
        return this._getReadyState() == XHRStreamHandler.OPENED;
    },
    isSocket: function () {
        return this.isConnecting() || this.isOpen();
    },
    _getHost: function () {
        this.setQueryParam('ts', util.ts());
        return this.url + this.getQueryString();
    },
    connect: function () {
        var host = this._getHost();
        debug.log('XHR', 'connect');
        this._responseOffset = 0;
        this.errored = null;
        try {
            this.xhr.open('GET', host);
            this.xhr.send(null);
            debug.log('XHR', 'send request', this.xhr);
        } catch (exc) {
            debug.group('stream connection error');
            debug.error('XHR failed', exc.message, exc.fileName + ' [line '+exc.lineNumber+']');
            this.onConnectionError();
            debug.groupEnd();
        }
    },
    close: function (error) {
        if (!this.xhr) {
            debug.warn('No XHR to abort');
            return;
        }
        debug.log('XHR', 'close', this.xhr, '(readyState: ' + this._getReadyState() + ' status: ' + this._getStatus() + ')');
        if (error) {
            this.errored = true;
        }
        this.xhr.abort();
    },
    _initXhr: function () {
        // Setup XMLHttpRequest
        var self = this;
        this.xhr.onreadystatechange = function xhrOnReadyStateChange () {
            self._onReadyStateChange();
        };
        this.xhr.onerror = function xhrOnError (e) {
            debug.group('stream error');
            debug.warn('XHR', 'onerror', e, self.xhr, '(status: ' + self._getStatus() + ')');
            self._onData();
            self.onError();
            self.onDisconnect();
            debug.groupEnd();
        };
        this.xhr.onabort = function xhrOnAbort (e) {
            debug.group('stream abort');
            debug.log('XHR', 'onabort', e, self.xhr, '(status: ' + self._getStatus() + ')');
            self._onData();
            if (self.errored ||self._getStatus() != 200) {
                self.onError();
            }
            self.onDisconnect();
            debug.groupEnd();
        };
        this.xhr.onload = function xhrOnLoad (e) {
            debug.group('stream close');
            debug.log('XHR', 'onload', e, self.xhr, '(status: ' + self._getStatus() + ')');
            self._onData();
            if (self._getStatus() != 200) {
                self.onError();
            }
            self.onDisconnect();
            debug.groupEnd();
        };
    },
    _parseChunk: function (chunk) {
        // Loop through lines
        var msgs = chunk.split('\n');
        var self = this;
        _.each(msgs, function parseChunk (msg, i) {
            if (msg) {
                var message;
                try {
                    message = self.parseJsonMessage(msg);
                } catch (e) {
                    // Incomplete line, reset the offset
                    self._responseOffset -= msg.length;
                    return false; // break
                }
                self.onMessage(message);
            }
            return true;
        });
    },
    
    _getStatus: function () {
        if (this.xhr) {
            return this.xhr.status;
        }
    },
    _getReadyState: function () {
        if (this.xhr) {
            return this.xhr.readyState;
        }
    },
    
    _onData: function () {
        this.reset();
        // this.xhr.responseText always contains the full response since we started streaming
        // Seek to the last offset in the text and update the offset
        var chunk = this.xhr.responseText.substr(this._responseOffset);
        this._responseOffset += chunk.length;
        // Parse the chunk
        this._parseChunk(chunk);
    },
    _onReadyStateChange: function () {
        // 0: The object has been created, but not initialized (the open method has not been called).
        // 1: A request has been opened, but the send method has not been called.
        // 2: The send method has been called. No data is available yet.
        // 3: Some data has been received; however, neither responseText nor responseBody is available.
        // 4: All the data has been received.
        if (this._getReadyState() == 2) {
            this.trigger('connected');
        }
        if (this._getReadyState() == 3 && this._getStatus() == 200) {
            this._onData();
        }
    }
});


module.exports = XHRStreamHandler;



//////////////////
// WEBPACK FOOTER
// ./app/src/xhrstreamhandler.js
// module id = Dudk
// module chunks = 1